import React from "react";
import PropTypes from "prop-types";
import {
  APanel,
  APanelBody,
  APanelHeader,
  APanelTitle
} from "@cisco-sbg-ui/magna-react";
import {t} from "i18next";
import {useSelector} from "react-redux";
// eslint-disable-next-line max-len
import SavedInvestigationsTable from "features/investigations/SavedInvestigationsTable/SavedInvestigationsTable";
// eslint-disable-next-line max-len
import TableFilter from "components/Table/TableFilter";
import {
  SavedInvestigationsContext,
  SavedInvestigationsProvider
} from "contexts/SavedInvestigationsContext";
import {
  selectInvestigationsLoading,
  selectInvestigationTotalRows
} from "store/selectors";

const SavedInvestigationsPanel = ({resultsPerPage, showTitle = true}) => {
  const results = useSelector(selectInvestigationTotalRows);
  const totalDisplay = (
    <div className="align-self-center text-no-wrap">
      {t("investigate.savedInvestigations.filters.totalRows", {
        count: results
      })}
    </div>
  );
  return (
    <SavedInvestigationsProvider>
      <APanel data-testid={"SavedInvestigationsPanel-Panel"}>
        <APanelHeader>
          <APanelTitle>
            {showTitle && t("investigate.savedInvestigations.title")}
          </APanelTitle>
          <TableFilter
            name="saved-investigations"
            loadingSelector={selectInvestigationsLoading}
            totalDisplay={totalDisplay}
            context={SavedInvestigationsContext}
          />
        </APanelHeader>
        <APanelBody>
          <SavedInvestigationsTable resultsPerPage={resultsPerPage} />
        </APanelBody>
      </APanel>
    </SavedInvestigationsProvider>
  );
};

SavedInvestigationsPanel.propTypes = {
  resultsPerPage: PropTypes.number,
  showTitle: PropTypes.bool
};

export default SavedInvestigationsPanel;
